import Button from "@mui/material/Button";
import { CloudUploadOutlined } from "@mui/icons-material";
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Tooltip } from "@mui/material";
import BulkQuestionsInput from "../../common/inputs/BulkQuestionsInput";
import { Download } from "lucide-react";

function BulkUploadDialog({ open, setOpen, path,setShowActions }: { open: boolean, setOpen: any; path: any,setShowActions:any }) {
    const handleClose = () => {
        setOpen(false);
        setShowActions(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <div className="flex flex-row justify-between">

                <DialogTitle>
                    Bulk Upload Questions Via Excel
                </DialogTitle>
                <DialogTitle>
                    <a
                        href="https://assets.kaksya.in/samples/question-upload-with-sections.xlsx"
                        download
                        className="flex gap-2 text-blue-900 cursor-pointer hover:underline"
                    >
                        <Download /> Sample
                    </a>
                </DialogTitle>

            </div>
            <DialogContent>
                <DialogContentText>
                    <BulkQuestionsInput path={path} onSuccess={(key: string) => {
                        handleClose();
                    }} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}


export const BulkUploadQuestionBankAction = ({ path,setShowActions }: any) => {
    const [open, setOpen] = React.useState(false);
    return <>
        <BulkUploadDialog open={open} setOpen={setOpen} path={path} setShowActions={setShowActions} />
        <Tooltip title="Bulk Upload">
            <Button onClick={() => {
                setOpen(true)
            }}>
                <CloudUploadOutlined />
                <span className="px-2">

                    Bulk UPLOAD (Excel)
                </span>
            </Button>
        </Tooltip>
    </>
};

